import { IScope, IRootScopeService, IDirective, IAugmentedJQuery, IAttributes, INgModelController, IDirectiveFactory } from "angular";
import { GoalService } from "../goalService";
import { ITag } from "@gtmhub/tags/models";
import { ITraceRootScopeService } from "@gtmhub/core/tracing";
import { OkrEvents } from "@gtmhub/okrs";

interface IGoalTagsScope extends IScope {
  goalId?: string;
  model: {
    tags: ITag[];
  };
  addTagToGoal(tag: ITag): void;
  removeTagFromGoal(tag: ITag): void;
}

export class GoalTagsDirective implements IDirective {
  scope = {
    goalId: "<?",
  };
  restrict = "E";
  require = "ngModel";
  templateUrl = require("./goal-tags.html");

  private okrEvents: OkrEvents;

  constructor(private $rootScope: IRootScopeService & ITraceRootScopeService, private goalService: GoalService) {}

  link(scope: IGoalTagsScope, element: IAugmentedJQuery, attrs: IAttributes, ctrl: INgModelController): void {
    this.okrEvents = new OkrEvents(scope);

    const commitTags = () => ctrl.$setViewValue([...scope.model.tags]);

    const commitTagsAndBroadcastChange = () => {
      commitTags();
      this.okrEvents.broadcastGoalsChanged("goalChanged");
      this.$rootScope.$broadcast("goalsChanged");
    };

    ctrl.$render = () => {
      scope.model = { tags: [...(ctrl.$modelValue || [])] };
    };

    scope.addTagToGoal = (tag: ITag) => {
      this.$rootScope.traceAction("add_tag_to_goal", () => {
        if (!scope.goalId) {
          commitTags();
          return;
        }

        this.goalService.addTagToGoal(tag.title, scope.goalId).then(
          () => commitTagsAndBroadcastChange(),
          () => {
            scope.model.tags = scope.model.tags.filter((t) => t.title !== tag.title);
          }
        );
      });
    };

    scope.removeTagFromGoal = (tag: ITag) => {
      this.$rootScope.traceAction("remove_tag_from_goal", () => {
        if (!scope.goalId) {
          commitTags();
          return;
        }

        this.goalService.removeTagFromGoal(tag, scope.goalId).then(
          () => commitTagsAndBroadcastChange(),
          () => {
            scope.model.tags = [...scope.model.tags, tag];
          }
        );
      });
    };
  }

  static factory(): IDirectiveFactory {
    const factory = ($rootScope: IRootScopeService & ITraceRootScopeService, goalService: GoalService) => new GoalTagsDirective($rootScope, goalService);
    factory.$inject = ["$rootScope", "GoalService"];
    return factory;
  }
}
